import script from "./AddToken.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToken.vue?vue&type=script&setup=true&lang=js"

import "./AddToken.vue?vue&type=style&index=0&id=eb109e72&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb109e72"]])

export default __exports__